import { Duration, type DurationLikeObject } from 'luxon'

/**
 * Returns a human readable display string for a given duration in seconds.
 * @param seconds duration in seconds
 * @param unitDisplay optional display style for units ('short' | 'long') default is 'long'
 * @returns human readable display string
 */
export function getNiceDuration(seconds: number, unitDisplay: 'short' | 'long' = 'long'): string {
  const timeObj: DurationLikeObject = {
    minutes: Math.round(seconds / 60),
  }
  if (seconds >= 3600) {
    timeObj.hours = 0
  }

  return Duration.fromObject(timeObj).normalize().toHuman({ unitDisplay }).replace(',', '')
}
